export const queryKeys = {
  AUTO_TASK_CONFIG_EMPLOYEE: 'AUTO_TASK_CONFIG_EMPLOYEE',
  AUTO_TASK_CONFIG: 'AUTO_TASK_CONFIG',
  AUTO_TASK_CONFIG_BUILDING: 'AUTO_TASK_CONFIG_BUILDING'
};
